<!-- 绑定工序 -->
<template>
  <div>
    <el-dialog
      :title="`绑定工序(已选${selfList.length})`"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <vxe-grid size="mini" border :height="256" :data="noChooseList" :columns="showColumn">
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link
              size="mini"
              type="success"
              icon="vxe-icon-lock-fill"
              title="绑定"
              @click="itemAdd(row)"
            >
              绑定
            </el-link>
          </template>
        </vxe-grid>
        <vxe-grid
          ref="refTable"
          class="m-t-10"
          size="mini"
          show-footer
          :height="256"
          :data="selfList"
          :columns="activeColumn"
          :footer-method="footerMethod"
        >
          <!-- slot_default -->
          <template #default_move>
            <span class="iconfont icon-drag cursor-move"></span>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link
              size="mini"
              type="danger"
              icon="vxe-icon-unlock-fill"
              title="解绑"
              @click="itemDelete(rowIndex)"
            >
              解绑
            </el-link>
          </template>
        </vxe-grid>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      sortable: null,
      selfShow: false,
      selfData: {},
      selfList: {},
      allList: [],
      headerFilterUrl: '/admin/gcvip/gongxu/searchHeard',
      filterData: {},
      showColumn: [
        { type: 'seq', width: 40, title: '序号' },
        { field: 'code', title: '工序编码', slots: { header: 'header_input' } },
        {
          field: 'name',
          title: '工序名称',
          width: 100,
          slots: { header: 'header_input' }
        },
        { field: 'fen_zu', title: '工序分组', slots: { header: 'header_input' } },
        { field: 'lei_xing', title: '工序类型', slots: { header: 'header_input' } },
        { field: 'gong_xu_dan_wei', title: '工序单位', slots: { header: 'header_input' } },
        { field: 'gong_xu_cheng_ben', title: '工序成本(元)', slots: { header: 'header_input' } },
        { field: 'biao_zhun_gong_shi', title: '标准工时(分钟)', slots: { header: 'header_input' } },
        { field: 'fu_zhu_gong_shi', title: '辅助工时(分钟)', slots: { header: 'header_input' } },
        { field: 'miao_shu', title: '工序描述', slots: { header: 'header_input' } },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeColumn: [
        {
          title: '排序',
          width: 40,
          slots: { default: 'default_move' }
        },
        { field: 'code', title: '工序编码' },
        { field: 'name', title: '工序名称', width: 100 },
        { field: 'fen_zu', title: '工序分组' },
        { field: 'lei_xing', title: '工序类型' },
        { field: 'gong_xu_dan_wei', title: '工序单位' },
        { field: 'gong_xu_cheng_ben', title: '工序成本(元)' },
        { field: 'biao_zhun_gong_shi', title: '标准工时(分钟)' },
        { field: 'fu_zhu_gong_shi', title: '辅助工时(分钟)' },
        { field: 'miao_shu', title: '工序描述' },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeSheBeiIndex: ''
    }
  },
  computed: {
    // 未选择数据列表
    noChooseList() {
      let result = []
      this.allList.forEach((itemSt) => {
        let isNotRepect = this.selfList.every((itemNd) => {
          return itemSt.id !== itemNd.id
        })
        if (isNotRepect) result.push(this.$util.deepCopy(itemSt))
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
    this.getMuBanAllList()
    this.rowDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy() // 销毁拖拽排序
    }
  },
  methods: {
    // 行拖拽
    rowDrop() {
      this.$nextTick(() => {
        let $table = this.$refs.refTable
        let $sortContent = $table.$el.querySelector('.body--wrapper>.vxe-table--body tbody')
        this.sortable = Sortable.create($sortContent, {
          handle: '.icon-drag',
          animation: 150,
          onEnd: ({ newIndex, oldIndex }) => {
            let data = this.$util.deepCopy(this.selfList)
            let oldItem = this.$util.deepCopy(data[oldIndex])
            // 上移
            if (newIndex < oldIndex) {
              if (newIndex === 0) {
                data.splice(oldIndex, 1)
                data.unshift(oldItem) // 顶部
              } else {
                data.splice(oldIndex, 1)
                data.splice(newIndex, 0, oldItem)
              }
            }
            // 下移
            if (newIndex > oldIndex) {
              if (newIndex === data.length - 1) {
                data.push(oldItem) // 底部
                data.splice(oldIndex, 1)
              } else {
                data.splice(newIndex + 1, 0, oldItem)
                data.splice(oldIndex, 1)
              }
            }
            this.selfList = this.$util.deepCopy(data)
          }
        })
      })
    },
    // 子表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (
            ['gong_xu_cheng_ben', 'biao_zhun_gong_shi', 'fu_zhu_gong_shi'].includes(column.field)
          ) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.getMuBanAllList()
    },
    // 获取所有工序
    getMuBanAllList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongxu/list3',
        data: {
          filterData: this.filterData,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.allList = res.data.page.list
        }
      })
    },
    // 项-绑定
    itemAdd(row) {
      let result = this.$util.deepCopy(row)
      this.selfList.push(result)
    },
    // 项-解绑
    itemDelete(index) {
      this.selfList.splice(index, 1)
    },
    // 项-设置
    async itemSet(index) {
      this.activeSheBeiIndex = index
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('update:list', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-link {
    vertical-align: inherit;
  }
}
</style>
